const SEPARATORS = /[- ./]/g;
const REPLACEMENT_CPR = /^[0-9]{6}[0-9A-Za-z]{4}$/;

/** Same acceptance rule as private.encrypt_cpr. */
export function isAcceptableCpr(value: string): boolean {
  const withoutSeparators = value.replace(SEPARATORS, '');
  if (withoutSeparators.length === 10 && REPLACEMENT_CPR.test(withoutSeparators)) {
    return true;
  }
  return value.replace(/\D/g, '').length === 10;
}

/**
 * Official CPR (OID urn:oid:1.2.208.176.1.2): ten digits after hyphen/space
 * removal. Letters are not stripped, so a replacement CPR such as 0703921VJ6
 * does not become 07039216.
 */
export function officialCprDigits(value: string | null | undefined): string | null {
  const compact = (value ?? '').replace(SEPARATORS, '').trim();
  if (!/^\d{10}$/.test(compact)) return null;
  return compact;
}

/**
 * Replacement CPR (erstatningspersonnummer): ten characters, last four may
 * include letters. Official ten-digit CPR is not returned. The value is not
 * logged.
 */
export function replacementCprValue(value: string | null | undefined): string | null {
  const compact = (value ?? '').replace(SEPARATORS, '').trim();
  if (compact.length !== 10 || !REPLACEMENT_CPR.test(compact)) return null;
  if (/^\d{10}$/.test(compact)) return null;
  return compact;
}

/**
 * Clinician-facing CPR: ddmmyy-xxxx.
 * `decrypt-cpr` returns ten digits. A value that is already hyphenated is
 * normalised. Anything else is returned unchanged (never logged here).
 */
export function formatCprDisplay(cpr: string): string {
  const compact = cpr.replace(SEPARATORS, '');
  if (compact.length === 10 && REPLACEMENT_CPR.test(compact)) {
    return `${compact.slice(0, 6)}-${compact.slice(6)}`;
  }
  const digits = cpr.replace(/\D/g, '');
  if (digits.length === 10) {
    return `${digits.slice(0, 6)}-${digits.slice(6)}`;
  }
  return cpr;
}
